import { Link } from 'react-router-dom';
import { CheckCircle, FileText, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { Blueprint } from '@/types';

interface BlueprintNotificationProps {
  blueprint: Blueprint;
  onClose: () => void;
}

export default function BlueprintNotification({ blueprint, onClose }: BlueprintNotificationProps) {
  return (
    <div className="fixed bottom-4 right-4 max-w-md animate-in slide-in-from-bottom-5">
      <div className="rounded-lg border bg-card p-4 shadow-lg">
        <div className="flex items-start gap-3">
          <div className="rounded-full bg-green-500/10 p-2">
            <CheckCircle className="h-5 w-5 text-green-500" />
          </div>
          <div className="flex-1 space-y-2">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <p className="font-semibold">Blueprint Created</p>
                <p className="text-sm text-muted-foreground">{blueprint.title}</p>
              </div>
              <button
                onClick={onClose}
                className="rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100"
              >
                <X className="h-4 w-4" />
              </button>
            </div>

            <Link to={`/blueprints/${blueprint.id}`}>
              <Button size="sm" variant="outline" className="w-full">
                <FileText className="mr-2 h-4 w-4" />
                View Blueprint
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
